const EMBEDDED_IMAGE_URL_REGEX = /^data:(image\/[a-zA-Z0-9.+-]+);base64,(.+)$/;

const MIME_TYPE_TO_EXTENSION: Record<string, string> = {
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
  "image/svg+xml": "svg",
};

export function isEmbeddedImageDataUrl(url: string) {
  return EMBEDDED_IMAGE_URL_REGEX.test(url);
}

export function isEmbeddedImageDataUrlCandidate(url: string) {
  return url.startsWith("data:image/");
}

export function getEmbeddedImageMimeType(url: string) {
  return EMBEDDED_IMAGE_URL_REGEX.exec(url)?.[1] ?? null;
}

export function blobToDataUrl(blob: Blob) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
        return;
      }

      reject(new Error("Failed to encode embedded image."));
    };
    reader.onerror = () => reject(reader.error ?? new Error("Failed to encode embedded image."));
    reader.readAsDataURL(blob);
  });
}

export function dataUrlToFile(url: string, filename: string) {
  const mimeType = getEmbeddedImageMimeType(url);
  if (!mimeType) throw new Error("Invalid embedded image data URL.");

  const extension = MIME_TYPE_TO_EXTENSION[mimeType];
  if (!extension) throw new Error(`Unsupported embedded image MIME type: ${mimeType}.`);

  const base64 = url.slice(url.indexOf(",") + 1);
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));

  return new File([bytes], `${filename}.${extension}`, { type: mimeType });
}

export function getImageAssetLabel(url: string, fallbackLabel: string) {
  if (isEmbeddedImageDataUrlCandidate(url)) return fallbackLabel;

  const basename = url.split("?")[0]?.split("#")[0]?.split("/").pop()?.trim();
  return basename && basename.length > 0 ? basename : fallbackLabel;
}
